import { Validator } from "@itk/react-form";
import { hasValue, hasValueAndNotEmpty } from "@itk/typescript-utils";
import { hasToBeEqualTo, hasToBeLowerOrEqualTo, hasToBetween, hasToNotExceedLimit, passwordRequirements } from "./validators.i18n";
import { calculateDuration, calculateMinutes, combineDateAndTime, compareDates } from "./date-utils";

export const isEqual =
  (otherValue: string | null, otherField: string): Validator<string> =>
  value =>
    hasValueAndNotEmpty(value) && value !== otherValue ? hasToBeEqualTo(otherField) : undefined;

export const password: Validator<string> = value => (hasValue(value) && !/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[^\s\da-zA-Z])\S{5,}$/.test(value) ? passwordRequirements() : undefined);

export const isGreater =
  (fromDate: Date | null, toDate: Date | null, otherValue: Date | null, isFrom: boolean, otherField1: string, otherField2: string): Validator<Date | null | undefined> =>
  value => {
    if (hasValue(fromDate) && hasValue(toDate) && hasValue(value) && hasValue(otherValue)) {
      let fromTime = null;
      let totime = null;
      if (isFrom) {
        fromTime = combineDateAndTime(fromDate, value as Date).toDate();
        totime = combineDateAndTime(toDate, otherValue).toDate();
      } else {
        fromTime = combineDateAndTime(fromDate, otherValue).toDate();
        totime = combineDateAndTime(toDate, value as Date).toDate();
      }

      const tempValue = compareDates(fromTime, totime, "isBefore", true);
      if (!tempValue) return hasToBeLowerOrEqualTo(otherField1, otherField2);
      return undefined;
    }
  };

export const isGreaterOrEqual =
  (otherValue: Date | null, checkGreater: boolean, otherField1: string, otherField2: string): Validator<Date | null | undefined> =>
  value => {
    // checkGreater = true => value should be less then otherValue and value is Todate
    if (hasValue(value) && hasValue(otherValue)) {
      const tempValue = checkGreater ? compareDates(value as Date, otherValue, "isSameOrAfter") : compareDates(value as Date, otherValue, "isSameOrBefore");

      if (!tempValue) return hasToBeLowerOrEqualTo(otherField1, otherField2);
      return undefined;
    }
  };

export const inBetween =
  (fromDate: Date | null, fromTime: Date | null, todate: Date | null, toTime: Date | null): Validator<number | null | undefined> =>
  value => {
    if (hasValueAndNotEmpty(value) && hasValue(fromDate) && hasValue(fromTime) && hasValue(todate) && hasValue(toTime)) {
      const fromtime = combineDateAndTime(fromDate, fromTime);
      const totime = combineDateAndTime(todate, toTime);
      const minutes = calculateMinutes(fromtime, totime);

      return value < minutes ? undefined : hasToBetween();
    } else return undefined;
  };

export const notExceedLimitForTime =
  (fromDate: Date | null, toDate: Date | null, otherValue: Date | null, isFrom: boolean): Validator<Date | null | undefined> =>
  value => {
    if (hasValue(value) && hasValue(fromDate) && hasValue(toDate) && hasValue(otherValue)) {
      let fromTime = null;
      let totime = null;
      if (isFrom) {
        fromTime = combineDateAndTime(fromDate, value as Date).toDate();
        totime = combineDateAndTime(toDate, otherValue).toDate();
      } else {
        fromTime = combineDateAndTime(fromDate, otherValue).toDate();
        totime = combineDateAndTime(toDate, value as Date).toDate();
      }
      const hours = calculateDuration(fromTime, totime);
      return hasValue(hours) && hours <= 24 ? undefined : hasToNotExceedLimit();
    } else {
      return undefined;
    }
  };

export const notExceedLimitForDate =
  (fromTime: Date | null, toTime: Date | null, otherValue: Date | null, isFrom: boolean): Validator<Date | null | undefined> =>
  value => {
    if (hasValue(value) && hasValue(fromTime) && hasValue(toTime) && hasValue(otherValue)) {
      let fromDate = null;
      let toDate = null;
      if (isFrom) {
        fromDate = combineDateAndTime(value as Date, fromTime).toDate();
        toDate = combineDateAndTime(otherValue, toTime).toDate();
      } else {
        fromDate = combineDateAndTime(otherValue, fromTime).toDate();
        toDate = combineDateAndTime(value as Date, toTime).toDate();
      }

      const hours = calculateDuration(fromDate, toDate);
      return hasValue(hours) && hours <= 24 ? undefined : hasToNotExceedLimit();
    } else return undefined;
  };
